/*
 * Class that helps keep storage seperated by types of storage using an internal name for marking storage data.
 */
export default class NamedStorage {

    private mInternalName: string;

    constructor(internalName: string) {
        this.mInternalName = internalName;
    }

    Get(name: string): any {
        return localStorage.getItem(`${this.mInternalName}:${name}`);
    }

    GetNumber(name: string): number {
        let item = localStorage.getItem(`${this.mInternalName}:${name}`);
        let final = item == null ? '0' : item;
        return Number.parseInt(final, undefined);
    }

    GetArray(name: string): string[] {
        let arr: string[] = [];
        let items = localStorage.getItem(`${this.mInternalName}:${name}`);
        let splitted = items?.split(';');

        if (splitted == null) {
            return arr;
        }

        arr = splitted;
        return arr;
    }

    Store(name: string, value: any) {
        localStorage.setItem(`${this.mInternalName}:${name}`, value);
    }

    StoreArray(name: string, values: string[]) {
        let val = values.join(";");
        localStorage.setItem(`${this.mInternalName}:${name}`, val);
    }

    StoreInArray(name: string, value: any) {
        let val = this.Get(name);
        if (val == null || val === "") {
            localStorage.setItem(`${this.mInternalName}:${name}`, value);
            return;
        }
        val = `${val};${value}`;
        localStorage.setItem(`${this.mInternalName}:${name}`, val);
    }

    Remove(name: string) {
        localStorage.removeItem(`${this.mInternalName}:${name}`);
    }

    Clear() {
        let length = localStorage.length;
        for (var i = 0, len = length; i < len; i++) {
            let key = localStorage.key(i);
            if (key?.startsWith(this.mInternalName)) {
                localStorage.removeItem(key);
            }
        }
    }
}
